export const SUBJECT_EMPLOYEE = "employee";
export const SUBJECT_DEPENDENT = "dependent";
export const SPONSOR_HP = "HP";
export const SPONSOR_CVS = "CVS";
export const NO_USER_FOUND = "Cannot find User";
